var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.copied ? '复制成功' : '复制',"placement":"top"}},[_c('i',{class:[
        {
          'el-icon-document-copy': !_vm.copied,
          'el-icon-check': _vm.copied,
        }
    ],on:{"click":_vm.copy}})])}
var staticRenderFns = []

export { render, staticRenderFns }